export default {
  methods: {
    updateReleaseNotes() {
      // TODO: migrate to patchUser helper
      this.$http
        .patch('/v3/fe/web-users', {
          releaseNotesVersion: import.meta.env.VITE_RELEASE_NOTES_VERSION
        })
        .then(async () => {
          await this.$auth.fetchUser();
        })
        .catch(err => {
          this.handleError({ error: err, code: '0x00000075' });
        });
    }
  }
};
